var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Bar } from 'react-chartjs-2';
import { BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, Tooltip } from 'chart.js';
import deepmerge from 'deepmerge';
import Grid from '../../../Grid/';
import EmptyState from '../../EmptyState';
Chart.register(BarController, BarElement, CategoryScale, Legend, LinearScale, Tooltip);
export function BarChart(_a) {
    var chartDimension = _a.chartDimension, chartData = _a.chartData, emptyState = _a.emptyState, hasEntries = _a.hasEntries, _b = _a.barChartOptions, barChartOptions = _b === void 0 ? undefined : _b, _c = _a.horizontalBarChart, horizontalBarChart = _c === void 0 ? false : _c, _d = _a.maintainAspectRatio, maintainAspectRatio = _d === void 0 ? false : _d, customFooter = _a.customFooter, _e = _a.showFooter, showFooter = _e === void 0 ? true : _e, _f = _a.showLegend, showLegend = _f === void 0 ? false : _f, _g = _a.stacked, stacked = _g === void 0 ? false : _g;
    var height = chartDimension.height, width = chartDimension.width;
    var theme = useTheme();
    // Chart config for horizontal bar chart
    var horizontalScaleConfig = {
        x: {
            stacked: stacked,
            grid: {
                display: true
            }
        },
        y: {
            stacked: stacked,
            grid: {
                display: false
            }
        }
    };
    // Base axis of the dataset for horizontal bar chart
    var horizontalDataset = 'y';
    // Chart config for vertical bar chart
    var verticalScaleConfig = {
        x: {
            stacked: stacked,
            grid: {
                display: false
            }
        },
        y: {
            stacked: stacked,
            grid: {
                display: true
            }
        }
    };
    // Base axis of the dataset for vertical bar chart
    var verticalDataset = 'x';
    // Default footer function to get sum of all tooltip items
    var footer = function (tooltipItems) {
        var sum = tooltipItems.reduce(function (acc, tooltipItem) { return acc + tooltipItem.parsed[horizontalBarChart ? 'x' : 'y']; }, 0);
        return "Total: ".concat(sum);
    };
    // Default bar chart config (vertical bar chart by default)
    var defaultChartConfig = {
        maintainAspectRatio: maintainAspectRatio,
        plugins: {
            legend: {
                display: showLegend
            },
            tooltip: {
                borderColor: theme.palette.divider,
                borderWidth: 2,
                boxPadding: 15,
                titleColor: theme.palette.text.primary,
                titleFont: {
                    size: 14
                },
                titleMarginBottom: 15,
                interaction: {
                    mode: 'index'
                },
                backgroundColor: theme.palette.background.default,
                bodyColor: theme.palette.text.primary,
                bodySpacing: 6,
                padding: theme.spacing(1.5),
                bodyFont: {
                    size: 14
                },
                usePointStyle: true,
                callbacks: {
                    footer: showFooter ? customFooter || footer : undefined
                },
                footerAlign: 'right',
                footerColor: theme.palette.text.primary,
                footerMarginTop: 15
            }
        },
        indexAxis: horizontalBarChart ? horizontalDataset : verticalDataset,
        scales: horizontalBarChart ? horizontalScaleConfig : verticalScaleConfig
    };
    // If barChartOptions are provided merge them into defaultChartConfig, if not use defaultChartConfig
    var options = barChartOptions ? deepmerge(defaultChartConfig, barChartOptions) : defaultChartConfig;
    return (React.createElement(Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justifyContent: "center", style: { width: width, height: height } }, hasEntries ? React.createElement(Bar, { data: chartData, options: options }) : React.createElement(EmptyState, __assign({}, emptyState))));
}
export default BarChart;
//# sourceMappingURL=BarChart.js.map